"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/operator/map");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/skip");
require("rxjs/add/operator/take");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var http_1 = require("@angular/common/http");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/observable/zip");
require("rxjs/add/observable/of");
require("rxjs/add/observable/throw");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
/**
 * HttpClient implementation of MessageService
 * @author gnuni.gevorgyan
 */
var HttpMessageService = /** @class */ (function () {
    /**
     * Construct HttpMessageService's instance
     * Get message service api url from applicationPropertiesService
     * and load by this url all available messages from server or from local json file by
     * @param http
     * @param currentLanguageProvider
     * @param applicationPropertiesService
     */
    function HttpMessageService(http, currentLanguageProvider, applicationPropertiesService) {
        var _this = this;
        this.http = http;
        this.currentLanguageProvider = currentLanguageProvider;
        this.applicationPropertiesService = applicationPropertiesService;
        // messages which will be loaded in coming request
        this.nextLoadingMessages = new Set();
        // messages that requested but don't received yet.
        this.pendingMessages = new Set();
        this.messagesByLanguage = new Map();
        this.currentMessages = new Map();
        this.currentLanguageMessages = new ReplaySubject_1.ReplaySubject(1);
        this.applicationPropertiesService
            .getProperty(HttpMessageService_1.messagesApiUrlKey)
            .then(function (url) {
            currentLanguageProvider
                .getCurrentLanguage()
                .skip(1)
                .subscribe(function (language) {
                _this.pendingMessages.clear();
                _this.loadNewLanguageMessages(language.getId(), url + HttpMessageService_1.messagesApiUrlEndpoint);
            });
        })
            .catch(HttpMessageService_1.handleError);
    }
    HttpMessageService_1 = HttpMessageService;
    /**
     * Check if messageKey does not contain in currentMessages then add it into nextLoadingMessages and call delayedLoad()
     * @returns String message which is associated with this messageKey
     */
    HttpMessageService.prototype.getMessage = function (messageKey) {
        if (!this.currentMessages.has(messageKey) && !this.nextLoadingMessages.has(messageKey) && !this.pendingMessages.has(messageKey)) {
            this.nextLoadingMessages.add(messageKey);
            this.delayedLoad();
        }
        return this.currentLanguageMessages.filter(function (messages) { return messages.get(messageKey) !== undefined; }).map(function (messages) {
            return messages.get(messageKey);
        });
    };
    HttpMessageService.prototype.getMessagesByCriteria = function (messageSearchCriteria) {
        var _this = this;
        return this.applicationPropertiesService
            .getProperty(HttpMessageService_1.messagesApiUrlKey)
            .then(function (uri) {
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
            var httpParams = _this.buildHttpParamsOfCriteria(messageSearchCriteria);
            var messagesApiUrl = uri + HttpMessageService_1.messagesApiUrlEndpoint;
            return _this.http.get(messagesApiUrl, {
                headers: headers,
                params: httpParams
            }).map(function (response) {
                var messagesByKeys = new Map();
                if (messageSearchCriteria.languageId) {
                    for (var _i = 0, _a = Object.keys(response); _i < _a.length; _i++) {
                        var key = _a[_i];
                        messagesByKeys.set(key, new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map([[messageSearchCriteria.languageId, response[key]]])));
                    }
                }
                else {
                    for (var _b = 0, _c = Object.keys(response); _b < _c.length; _b++) {
                        var key = _c[_b];
                        var messages = new Map();
                        for (var _d = 0, _e = Object.keys(response[key]); _d < _e.length; _d++) {
                            var languageId = _e[_d];
                            messages.set(+languageId, response[key][languageId]);
                        }
                        messagesByKeys.set(key, new idm_crosscutting_concepts_frontend_1.MultilingualString(messages));
                    }
                }
                return messagesByKeys;
            }).toPromise();
        });
    };
    HttpMessageService.prototype.getDetailedMessagesByCriteria = function (messageSearchCriteria) {
        var _this = this;
        return this.applicationPropertiesService
            .getProperty(HttpMessageService_1.messagesApiUrlKey)
            .then(function (uri) {
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
            var httpParams = _this.buildHttpParamsOfCriteria(messageSearchCriteria).append('extended', 'true');
            var messagesApiUrl = uri + HttpMessageService_1.messagesApiUrlEndpoint;
            return _this.http.get(messagesApiUrl, {
                headers: headers,
                params: httpParams
            }).map(function (response) {
                var detailedMessages = [];
                for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
                    var item = response_1[_i];
                    detailedMessages.push({
                        key: item.key,
                        values: item.message,
                        typeId: item.typeId,
                        componentId: item.componentId,
                        description: item.description
                    });
                }
                return detailedMessages;
            }).toPromise();
        });
    };
    /**
     * Get message by messageKey and replace all placeHolders
     *
     */
    HttpMessageService.prototype.getMessageWithPlaceholder = function (messageKey, placeholders) {
        return this.getMessage(messageKey).map(function (message) {
            return HttpMessageService_1.replacePlaceHolders(message, placeholders);
        });
    };
    HttpMessageService.prototype.getMessages = function (languageId, messageKeys) {
        var _this = this;
        if (messageKeys.length === 0) {
            return Promise.resolve(new Map());
        }
        var keysToLoad = new Set();
        var existingMessages = this.messagesByLanguage.get(languageId) || new Map();
        messageKeys.forEach(function (messageKey) {
            if (!existingMessages.has(messageKey)) {
                keysToLoad.add(messageKey);
            }
        });
        if (keysToLoad.size === 0) {
            var messages_1 = new Map();
            messageKeys.forEach(function (key) { return messages_1.set(key, existingMessages.get(key)); });
            return Promise.resolve(messages_1);
        }
        keysToLoad.forEach(function (key) { return _this.pendingMessages.add(key); });
        return this.applicationPropertiesService
            .getProperty(HttpMessageService_1.messagesApiUrlKey)
            .then(function (uri) {
            return _this.getMessagesFromServer(new Set(messageKeys), languageId, uri + HttpMessageService_1.messagesApiUrlEndpoint)
                .then(function (res) {
                var messages = HttpMessageService_1.extractMessages(res);
                // on this point there may be messages loaded into messagesByLanguage map, so reassigning existingMessages to it
                existingMessages = _this.messagesByLanguage.get(languageId) || new Map();
                messages.forEach(function (value, key) { return existingMessages.set(key, value); });
                _this.messagesByLanguage.set(languageId, existingMessages);
                _this.currentLanguageMessages.next(existingMessages);
                keysToLoad.forEach(function (key) { return _this.pendingMessages.delete(key); });
                var requestMessages = new Map();
                messageKeys.forEach(function (key) { return requestMessages.set(key, existingMessages.get(key)); });
                return requestMessages;
            });
        })
            .catch(HttpMessageService_1.handleError);
    };
    HttpMessageService.prototype.getMessagesWithPlaceholder = function (languageId, messageKeys, placeholders) {
        return this.getMessages(languageId, messageKeys).then(function (messagesByKeys) {
            return new Map(messageKeys.map(function (key, index) {
                var message = messagesByKeys.get(key);
                return [key, message && HttpMessageService_1.replacePlaceHolders(message, placeholders[index])];
            }));
        });
    };
    HttpMessageService.prototype.partialUpdateMessages = function (messages) {
        var _this = this;
        return this.applicationPropertiesService
            .getProperty(HttpMessageService_1.messagesApiUrlKey)
            .then(function (serviceUrl) {
            var headers = new http_1.HttpHeaders()
                .set('Content-Type', 'application/json');
            var body = [];
            messages.forEach(function (message) { return body.push({
                key: message.key,
                message: message.values,
                typeId: message.typeId,
                componentId: message.componentId,
                description: message.description
            }); });
            return _this.http.patch(serviceUrl + HttpMessageService_1.messagesApiUrlEndpoint, body, { headers: headers })
                .toPromise()
                .then(function () {
                _this.currentLanguageProvider.getCurrentLanguage().take(1).subscribe(function (currentLanguage) {
                    _this.messagesByLanguage.forEach(function (languageMessages, languageId) {
                        messages.forEach(function (message) { return languageMessages.set(message.key, message.values[languageId]); });
                    });
                    messages.forEach(function (message) { return _this.currentMessages.set(message.key, message.values[currentLanguage.getId()]); });
                    _this.currentLanguageMessages.next(_this.currentMessages);
                });
            });
        });
    };
    HttpMessageService.prototype.buildHttpParamsOfCriteria = function (criteria) {
        var httpParams = {};
        if (criteria.languageId) {
            httpParams['languageId'] = String(criteria.languageId);
        }
        if (criteria.keys) {
            var keysParam_1 = '';
            criteria.keys.forEach(function (key) {
                keysParam_1 += key + ',';
            });
            httpParams['keys'] = keysParam_1;
        }
        if (criteria.componentIds) {
            var componentsParam_1 = '';
            criteria.componentIds.forEach(function (key) {
                componentsParam_1 += key + ',';
            });
            httpParams['componentIds'] = componentsParam_1;
        }
        if (criteria.typeIds) {
            var typesParam_1 = '';
            criteria.typeIds.forEach(function (key) {
                typesParam_1 += key + ',';
            });
            httpParams['typeIds'] = typesParam_1;
        }
        if (criteria.search) {
            httpParams['search'] = criteria.search;
        }
        if (criteria.paging) {
            httpParams['offset'] = criteria.paging.offset;
            httpParams['count'] = criteria.paging.count;
        }
        if (criteria.sorting) {
            httpParams['sortField'] = criteria.sorting.field;
            httpParams['sortOrder'] = criteria.sorting.order;
        }
        return new http_1.HttpParams({ fromObject: httpParams });
    };
    /**
     * If delayedLoadTimeOutId is not undefined then clear timeout
     * Call window.setTimeout 100ms and set id on delayedLoadTimeOutId
     */
    HttpMessageService.prototype.delayedLoad = function () {
        var _this = this;
        if (this.delayedLoadTimeOutId) {
            clearTimeout(this.delayedLoadTimeOutId);
        }
        this.delayedLoadTimeOutId = window.setTimeout(function () {
            return _this.loadUnloadedMessages();
        }, 100);
    };
    /**
     * Check if nextLoadingMessages is not empty then call to server and fetch messages,
     * Load all unloaded messages and put them into the current language messages map
     * After that clear nextLoadingMessages
     */
    HttpMessageService.prototype.loadUnloadedMessages = function () {
        var _this = this;
        this.applicationPropertiesService
            .getProperty(HttpMessageService_1.messagesApiUrlKey)
            .then(function (uri) {
            _this.currentLanguageProvider
                .getCurrentLanguage()
                .take(1)
                .subscribe(function (language) {
                if (_this.nextLoadingMessages.size > 0) {
                    var languageId_1 = language.getId();
                    var nextLoadingMessagesCopy = new Set(_this.nextLoadingMessages);
                    _this.nextLoadingMessages.clear();
                    nextLoadingMessagesCopy.forEach(function (item) { return _this.pendingMessages.add(item); });
                    _this.getMessagesFromServer(nextLoadingMessagesCopy, languageId_1, uri + HttpMessageService_1.messagesApiUrlEndpoint)
                        .then(function (res) {
                        var messages = HttpMessageService_1.extractMessages(res);
                        var languageMessages = _this.messagesByLanguage.get(languageId_1) || new Map();
                        messages.forEach(function (value, key) {
                            languageMessages.set(key, value);
                            _this.pendingMessages.delete(key);
                        });
                        _this.messagesByLanguage.set(languageId_1, languageMessages);
                        _this.currentLanguageMessages.next(languageMessages);
                        _this.currentMessages = languageMessages;
                    }).catch(HttpMessageService_1.handleError);
                }
            });
        })
            .catch(HttpMessageService_1.handleError);
    };
    /**
     * Check if Switched language is never loaded then load all messages by previous language's messages' keys
     * If Switched language contains in messagesByLanguage map then filter messagesKeys and call to server by unloaded messages
     * After that set all filtered messages' keys and values on current messages
     * And finally call currentLanguages.next()
     */
    HttpMessageService.prototype.loadNewLanguageMessages = function (languageId, messagesApiUrl) {
        var _this = this;
        var messagesKeys = new Set();
        this.currentMessages.forEach(function (value, key) { return messagesKeys.add(key); });
        this.nextLoadingMessages.forEach(function (value) { return messagesKeys.add(value); });
        this.nextLoadingMessages.clear();
        if (messagesKeys.size > 0) {
            var currentMessages_1 = this.messagesByLanguage.get(languageId);
            if (!currentMessages_1) {
                this.getMessagesFromServer(messagesKeys, languageId, messagesApiUrl)
                    .then(function (res) {
                    var messages = HttpMessageService_1.extractMessages(res);
                    _this.messagesByLanguage.set(languageId, messages);
                    _this.currentLanguageMessages.next(messages);
                    _this.currentMessages = messages;
                }).catch(HttpMessageService_1.handleError);
            }
            else {
                var filteredMessageKeys_1 = new Set();
                messagesKeys.forEach(function (key) {
                    if (!currentMessages_1.has(key)) {
                        filteredMessageKeys_1.add(key);
                    }
                });
                if (filteredMessageKeys_1.size > 0) {
                    this.getMessagesFromServer(filteredMessageKeys_1, languageId, messagesApiUrl)
                        .then(function (res) {
                        var messages = HttpMessageService_1.extractMessages(res);
                        currentMessages_1 = _this.messagesByLanguage.get(languageId);
                        messages.forEach(function (value, key) {
                            currentMessages_1.set(key, value);
                        });
                        _this.currentMessages = currentMessages_1;
                        _this.currentLanguageMessages.next(_this.currentMessages);
                    }).catch(HttpMessageService_1.handleError);
                }
                else {
                    this.currentMessages = this.messagesByLanguage.get(languageId);
                    this.currentLanguageMessages.next(this.currentMessages);
                }
            }
        }
    };
    /**
     * Call to server and fetch messages by messagesKeys
     */
    HttpMessageService.prototype.getMessagesFromServer = function (messagesKeys, languageId, messagesApiUrl) {
        var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
        var requestParams = '?languageId=' + languageId + '&keys=';
        messagesKeys.forEach(function (key) {
            requestParams += key + ',';
        });
        if ((messagesApiUrl + requestParams).length < 2000) { // allowed URL length
            return this.http.get(messagesApiUrl + requestParams, { headers: headers }).toPromise();
        }
        else {
            return this.http.post(messagesApiUrl + ("?languageId=" + languageId), Array.from(messagesKeys), { headers: headers }).toPromise();
        }
    };
    /**
     * Get Message value from map and replace placeholders
     * @returns Message value for current messageKey
     */
    HttpMessageService.replacePlaceHolders = function (messageKey, placeholders) {
        if (placeholders != null && placeholders.length !== 0) {
            for (var i = 0; i < placeholders.length; i++) {
                var placeholder = placeholders[i];
                messageKey = messageKey.replace('{' + i + '}', placeholder);
            }
        }
        return messageKey;
    };
    /**
     * Extracts messages from response
     * @param res Response
     * @returns {Map<string,string>} messages
     */
    HttpMessageService.extractMessages = function (res) {
        return HttpMessageService_1.convertObjectToMap(res);
    };
    /**
     * Converts Object to Map
     * @param obj
     * @returns {Map<number, string>}
     */
    HttpMessageService.convertObjectToMap = function (obj) {
        var strMap = new Map();
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var k = _a[_i];
            strMap.set(k, obj[k]);
        }
        return strMap;
    };
    /**
     * Converts Map to Object
     * @param map
     * @returns object
     */
    HttpMessageService.convertMapToObject = function (map) {
        var obj = {};
        map.forEach(function (value, key) { return obj[key] = value; });
        return obj;
    };
    /**
     * Handle errors
     */
    HttpMessageService.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    HttpMessageService.messagesApiUrlKey = 'ml-service-url';
    HttpMessageService.messagesApiUrlEndpoint = '/messages';
    HttpMessageService = HttpMessageService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient, idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpMessageService);
    return HttpMessageService;
    var HttpMessageService_1;
}());
exports.HttpMessageService = HttpMessageService;
//# sourceMappingURL=http-message.service.js.map